const configBoardTemplate = {
    notice: {
        listLayout: 'BoardListDefaultLayout',
        paginationLayout: 'PaginationtDefaultLayout',
        filterLayout: 'BoardFilterDefaultLayout'
    },
    noticeCreate: {
        optionLayouts: ['BoardInputLayout'],
    },
    noticeUpdate: {
        optionLayouts: ['BoardInputLayout'],
    },
    faq: {
        listLayout: 'BoardListFaqLayout',
        paginationLayout: 'PaginationtDefaultLayout',
        filterLayout: 'BoardFilterNoDateLayout'
    },
    faqCreate: {
        optionLayouts: ['BoardInputLayout'],
    },
    faqUpdate: {
        optionLayouts: ['BoardInputLayout'],
    },
    refund: {
        listLayout: 'BoardListRefundLayout',
        paginationLayout: 'PaginationtNoDeleteLayout',
        filterLayout: 'BoardFilterRefundLayout'
    },
    refundAnswer: {
        optionLayouts: ['BoardInfoLayout', 'BoardAnswerInputLayout'],
    },
    qa: {
        listLayout: 'BoardListQaLayout',
        paginationLayout: 'PaginationtNoDeleteLayout',
        filterLayout: 'BoardFilterQaLayout'
    },
    qaAnswer: {
        optionLayouts: ['BoardQaInfoLayout', 'BoardQaAnswerInputLayout'],
    },
}

export default {
    methods: {
        returnBoardTemplateConfig(type) {
            return configBoardTemplate[type];
        }
    }
}